import { FC } from 'react';

import { Survey } from '~/widgets/survey/Survey';

import { MFBaseProvider } from '../providers/MFBaseProvider';
import { MFSurveyFormContextPropsType, MFSurveyFormProvider } from '../providers/MFSurveyFormProvider';

const MFSurveyForm: FC<MFSurveyFormContextPropsType> = (props) => {
  return (
    <MFBaseProvider {...props}>
      <MFSurveyFormProvider {...props}>
        <Survey />
      </MFSurveyFormProvider>
    </MFBaseProvider>
  );
};

export default MFSurveyForm;
